import React from "react";
import "./NineComponent.css";
import BaseButton from "../../../components/Button/BaseButton";
const NineComponent = () => {
  const queryparam = window.location.search;
  const connectToPlay = () => {
    window.open(`https://cryptoclash.gg/trade${queryparam}`, "_self");
  };

  return (
    <div className="seven-parnet">
      <div className="container">
        <div className="row">
          <div className="col-md-6 ">
            <div className="image-nine-beside">
              <img
                src="https://storage.googleapis.com/anima-react/nineimage.png"
                className="nine-beside-image"
              />
            </div>
          </div>
          <div className="col-md-6">
            <ul>MONTHLY JACKPOT</ul>
            <h3>
              10% of the platform's income will be raffled among all the
              participants in the game.
            </h3>
            <p>
              Each transaction you take earns you a lottery ticket, the more you
              play, the more lottery tickets you will have and your chances of
              winning will increase, good luck!
            </p>
            <div className="row">
              <div className="col how-to-play-nine">
                <BaseButton title="Play " onClick={connectToPlay} />
                <button
                  className="btn"
                  onClick={connectToPlay}
                  style={{ cursor: "pointer" }}
                >
                  And earn crypto
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NineComponent;
